const ALL_INTERVALS = {
  0: 'Once',
  2629746: 'Every Month',
  5259492: 'Every 2 Months',
  7889238: 'Every 3 Months',
  10518984: 'Every 4 Months',
  13148730: 'Every 5 Months',
  15778476: 'Every 6 Months',
};

const ONLY_MONTHS = {
  2629746: '1 Month',
  5259492: '2 Months',
  7889238: '3 Months',
  10518984: '4 Months',
  13148730: '5 Months',
  15778476: '6 Months',
};

const DELIVERY_INTERVALS = {
  ALL_INTERVALS,
  ONLY_MONTHS,
};

export default DELIVERY_INTERVALS;
